import React, { FC } from 'react';
import { useTheme } from 'styled-components';

interface IChartLabel {
  labels: string[];
}

const ChartLabels: FC<IChartLabel> = ({ labels }) => {
  const theme = useTheme();

  const [start, end] = labels;

  return (
    <g>
      <text
        x="50%"
        dx={-96}
        y={164}
        fill={theme.colors.neutral.primary[80]}
        fontSize="14"
        fontWeight="700"
      >
        {start}
      </text>
      <text
        x="50%"
        dx={80}
        y={164}
        fill={theme.colors.neutral.primary[80]}
        fontSize="14"
        fontWeight="700"
      >
        {end}
      </text>
    </g>
  );
};

export default ChartLabels;
